<template>
  <v-container class="fill-height d-flex align-center justify-center" style="min-height: 80vh;">
    <div v-if="loadingPage" class="text-center">
      <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
    </div>
    <v-card v-else flat max-width="480" class="text-center pa-8 mx-auto">
      <v-icon size="64" color="primary" class="mb-4">mdi-shield-account-outline</v-icon>
      <h2 class="text-h5 font-weight-bold mb-3">{{ $t('message.no_academy') }}</h2>
      <div class="mb-6">
        <AcademySelect :label="$t('message.select_academy')" outlined :force-select="true"></AcademySelect>
      </div>
      <v-divider class="mb-6"></v-divider>
      <div v-if="!$store.state.inApp" class="mt-2">
        <p class="body-2 grey--text mb-3">{{ $t('message.not_supposed_here') }}</p>
        <v-btn color="error" elevation="0" small @click="logout()">
          <v-icon class="mr-1">mdi-logout</v-icon>
          {{ $t("message.logout") }}
        </v-btn>
      </div>
    </v-card>
  </v-container>
</template>
<script>
import AcademySelect from "@/components/inputs/AcademySelect.vue";
import Api from "@/services/Api";

export default {
  data() {
    return {
      loadingPage: true,
    };
  },
  created() {
    // 1. If we don't have a token, we shouldn't even be trying to fetch permissions.
    // This stops the 401 loop immediately.
    if (!localStorage.token) {
      console.log('NoAcademy: No token found. Stopping auto-redirect logic.');
      this.$store.dispatch("setSelectedAcademy", null);
      this.$store.dispatch("setManagedAcademy", null);
      this.loadingPage = false;
      return;
    }

    // 2. Only attempt auto-navigation if we have BOTH an academy AND a token
    if (this.$store.state.managedAcademy && this.$store.state.user && this.$store.state.user._id) {
      Api()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/admin/" +
          this.$store.state.user._id +
          "/permissions"
        )
        .then((response) => {
          if (response.data.academy && response.data.permissions) {
            this.$store.dispatch("setPermissions", response.data.permissions);
            this.$store.dispatch("setSelectedAcademy", response.data.academy);
            this.navigateTo({ name: "home" });
          } else {
            this.loadingPage = false;
          }
        })
        .catch((err) => {
          // 3. IMPORTANT: If the API fails (401/403), STAY on this page.
          // Do not let an interceptor trigger a reload.
          console.error("NoAcademy: Permission check failed", err);
          this.$store.dispatch("setSelectedAcademy", null);
          this.$store.dispatch("setManagedAcademy", null);
          this.loadingPage = false;
        });
    } else {
      this.$store.dispatch("setSelectedAcademy", null);
      this.$store.dispatch("setManagedAcademy", null);
      this.loadingPage = false;
    }
  },
  components: {
    AcademySelect
  },
  methods: {
    logout() {
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setInApp", false);
      this.$store.dispatch("setSelectedAcademy", null);
      this.$store.dispatch("setManagedAcademy", null);
      this.$store.dispatch("setStripeAccountId", null);
      localStorage.removeItem('vuex');
      localStorage.removeItem('token');
      window.location.replace("/login?to=admin");
    },
  }
}
</script>

<style scoped></style>